import { __assign } from "tslib";
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useDayPicker } from 'contexts/DayPicker';
/** Render the Footer component (empty as default).*/
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function Footer(props) {
    var _a = useDayPicker(), footer = _a.footer, styles = _a.styles, tfoot = _a.classNames.tfoot;
    if (!footer)
        return _jsx(_Fragment, {});
    return (_jsx("tfoot", __assign({ className: tfoot, style: styles.tfoot }, { children: _jsx("tr", { children: _jsx("td", __assign({ colSpan: 8 }, { children: footer })) }) })));
}
//# sourceMappingURL=Footer.js.map